import styled, { withTheme } from 'styled-components';

const Style = styled.div`
    margin:5px 5px 40px 5px;
    .introContent {
        max-width: 610px;
        h1 {
            font-size: 19px;
            color: ${props => props.theme.gold};
            text-transform: uppercase;
            font-weight: 600;
        }
        p {
            font-weight: 300;
        }
    }
    form {
        max-width: 610px;
        label {
            font-weight: 500;
        }
        input.form-control {
            height: calc(1.5em + 0.75rem + 5px);
            border-radius: 0;        
        }
        button {
            font-weight: 500 !important;
            text-transform: uppercase;
            height: auto;
            padding: 9px 15px;
            border-radius: 0 !important;
            text-align: center;
            min-width: 120px;
            background: #b1956a;
            border-color: #b1956a;
            color: #fff;
            .button-content {
                font-weight: 400;
                font-size: 14px;
            }
            &:hover {
                background: #717274;
                border-color: #717274;
                color: #fff;
                opacity: 1;
            }
        }
    }
    
    .resultBox {
        width: 100%;
        max-width: 1000px;
        border: 1px solid ${props => props.theme.bordergrey};
        padding: 30px;
        text-align: center;
        h3 {
            font-size: 18px;
            color: ${props => props.theme.gold};
            font-weight: 600;
        }
        p.resultFigure {
            font-size: 43px;
            font-weight: 200;
            &.red {
                color: ${props => props.theme.red};
            }
        }
        p.resultSuffix {
            font-size: 15px;
            max-width: 750px;
            margin: auto;
        }
    }

    
`;

export default withTheme(Style);
